import { forwardRef } from 'react';
import cx from 'classnames';
import { take, uniqBy } from 'lodash';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { GenerationToolIcon } from 'src/components/GenerationToolIcon';
import { getGenerationToolIcon } from 'src/components/GenerationToolIcon/utils';

import { useStyles } from './useStyles';

export const GenerationToolsIcons = forwardRef(
  ({ className, tools, maxVisible, ...restProps }, ref) => {
    const styles = useStyles();

    const visibleCount = maxVisible > 0 ? maxVisible : Number.MAX_SAFE_INTEGER;
    const uniqIconTools = uniqBy(tools, getGenerationToolIcon);

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
        {...restProps}
      >
        {take(uniqIconTools, visibleCount).map((tool, i) => (
          <GenerationToolIcon
            className={styles.icon}
            key={tool + i}
            tool={tool}
          />
        ))}

        {uniqIconTools.length > visibleCount && (
          <CustomTypography variant={TYPOGRAPHY_VARIANT.regular12}>
            +{uniqIconTools.length - visibleCount}
          </CustomTypography>
        )}
      </div>
    );
  }
);

GenerationToolsIcons.propTypes = {
  className: PropTypes.string,
  tools: PropTypes.arrayOf(PropTypes.string),
  maxVisible: PropTypes.number,
};

GenerationToolsIcons.defaultProps = {
  className: null,
  tools: [],
  maxVisible: null,
};
